export default "__VITE_ASSET__BvQ0TYJL__"